<template>
	<div>
		<p class="text-right">
			<TogglePinned :item="group" :id="id" collection="groups"></TogglePinned>
		</p>
		<v-row>
			<v-col>
				<GroupOverview :id="id"></GroupOverview>	
			</v-col>
			<v-col cols="12" md="7">
				<v-card class="pa-4">					
					<GroupForm :doc="group" @change="(u) => updated_details = u"></GroupForm>
					<p class="text-right">
						<SaveSavingSaved :status="status" @save="updateGroup"></SaveSavingSaved>
					</p>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-card class="pa-4">
					<h5 class="cn-font grey--text">Vorgänge</h5>

					<v-dialog width="400px" v-for="collab in groupCollabs" :key="collab.id">
						<template v-slot:activator="{ on}">
							<v-chip class="mr-2 mt-2" color="primary" close v-on="on" @click:close="removeCollaboration(collab.id)">
								{{ collab.name }}
							</v-chip>
						</template>
						<DisplayCollaboration :collaboration="collab"></DisplayCollaboration>
					</v-dialog>	
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<GroupNotes :id="id"></GroupNotes>
			</v-col>
		</v-row>
		<p>
			<BackButton></BackButton>
		</p>

	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import TogglePinned from "@/components/elements/TogglePinned"
	import SaveSavingSaved from "@/components/elements/SaveSavingSaved"
	import GroupOverview from "@/components/assessment/groups/GroupOverview"
	import GroupForm from "@/components/assessment/groups/GroupForm"
	import GroupNotes from "@/components/assessment/groups/GroupNotes"
	import DisplayCollaboration from "@/components/assessment/collaborations/DisplayCollaboration"
	import BackButton from "@/components/elements/BackButton"

	export default {
		name: "Group", 
		props: {
			id: {type: String}
		},
		data: () => {
			return {
				status: null,
				updated_details: {}
			}
		}, 
		components: {
			BackButton,
			TogglePinned,
			GroupOverview,
			GroupForm,
			GroupNotes,
			SaveSavingSaved, 
			DisplayCollaboration
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				users: state => state.users || [],
				groups: state => state.groups || [],
				organisations: state => state.organisations || [],
				assessments: state => state.assessments || [],
				collaborations: state => state.collaborations || []
			}),
			assessment_details(){
				var assessment = this.assessment;
				return this.assessments.find( a => a.id == assessment )
			},
			group(){
				var id = this.id;
				return this.groups.find( group => group.id == id )
			},
			groupCollabs(){
				var id = this.id;
				return this.collaborations.filter( collab => collab.members.indexOf(id) > -1 )
			},
			organisation(){
				return this.assessment_details.organisation;
			},

		},
		watch: {
			updated_details(){
				this.status = "unsaved";
			}
		},
		methods: {
			updateGroup(){
				this.status = "saving";
				this.$store.dispatch("groups/update", {group_id: this.id, update: this.updated_details})
				this.status = "saved"
			},
			removeCollaboration(id){
				this.$store.dispatch("collaborations/removeMember", {member_id: this.id, collab_id: id})
			}
		}
		// created(){
			
		// }

	}
</script> 